import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';
import CustomDataTable from '../../../../Components/CustomTable/CustomTable';
import { Triangle } from 'react-loader-spinner';
import { RestroUsers } from '../../../../services/DatabaseService/RestroUsers';

const ContactPersonLogs = () => {
    const { apiKey } = useParams();
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState(null);
    const [contactPersons, setContactPersons] = useState([]);

    useEffect(() => {
        const fetchAllData = async () => {
            setLoading(true);
            try {
                const result = await RestroUsers.getByApiKey(apiKey);
                setUserData(result);
                setContactPersons(result?.contactPersons || []);
            } catch (error) {
                console.error("Error fetching contact persons", error);
            } finally {
                setLoading(false);
            }
        };
        fetchAllData();
    }, [apiKey]);

    const customStyles = {
        headCells: {
            style: {
                fontSize: "0.92rem",
                fontWeight: 610,
                width: "max-content",
            },
        },
        rows: {
            style: {
                fontSize: "0.9rem",
            },
        },
    };

    const columns = [
        {
            name: "S No",
            selector: (row, index) => index + 1,
            width: "90px",
            sortable: true,
        },
        {
            name: "Name",
            selector: (row) => row.contactPersonName,
            sortable: true,
        },
        {
            name: "Email",
            selector: (row) => row.contactPersonEmail,
            sortable: true,
        },
        {
            name: "Phone",
            selector: (row) => row.contactPersonPhone,
            sortable: true,
        },
        {
            name: "Designation",
            selector: (row) => row.designation,
            sortable: true,
        },
        {
            name: "Remarks",
            selector: (row) => <span title={row.remarks}>{row.remarks}</span>,
            sortable: true,
        },
    ];

    return (
        <div className='page-content py-0'>
            <div className='container-fluid px-0'>

                {/* DESKTOP TABLE VIEW */}
                <Card className="d-none d-md-block d-lg-block">
                    <CardBody>
                        <CustomDataTable
                            responsive
                            striped
                            pagination
                            fixedHeader
                            persistTableHead
                            customStyles={customStyles}
                            progressPending={loading}
                            progressComponent={
                                <div className="my-3 d-flex flex-column align-items-center">
                                    <Triangle visible={true} height="80" width="80" color="#5B71B9" />
                                    <h5 className="mt-2">Loading...</h5>
                                </div>
                            }
                            columns={columns}
                            data={contactPersons || []}
                        />
                    </CardBody>
                </Card>

                {/* MOBILE VIEW CARDS */}
                {loading ? (
                    <div className="my-5 text-center d-block d-md-none">
                        <h5>Loading...</h5>
                    </div>
                ) : (
                    <>
                        {contactPersons?.map((item, index) => (
                            <Card key={index} className="mb-3 shadow-sm d-block d-md-none mt-2">
                                <CardBody>
                                    <h6 className="mb-2">
                                        <strong>S No:</strong> {index + 1}
                                    </h6>

                                    <h6 className="mb-2">
                                        <strong>Name:</strong> {item.contactPersonName}
                                    </h6>

                                    <h6 className="mb-2">
                                        <strong>Email:</strong> {item.contactPersonEmail}
                                    </h6>

                                    <h6 className="mb-2">
                                        <strong>Phone:</strong> {item.contactPersonPhone}
                                    </h6>

                                    <h6 className="mb-2">
                                        <strong>Designation:</strong> {item.designation}
                                    </h6>

                                    <h6 className="mb-2 text-wrap">
                                        <strong>Remarks:</strong> {item.remarks}
                                    </h6>
                                </CardBody>
                            </Card>
                        ))}
                    </>
                )}

            </div>
        </div>
    );
};

export default ContactPersonLogs;
